export default {
    "Score": [
        "10-55",
        "60-95",
        "100-125",
        "130-125",
    ],
    "CEFR": [
        "A1/A2",
        "B1",
        "B2",
        "C1/C2",

    ],
    "Abilities": [
        [
            "Can understand very basic English words and phrases.",
            "Can understand straightforward information and express themselves in familiar contexts."
        ],
        [
            "Can understand the main points of concrete speech or writing on routine matters such as work and school",
            "Can describe experiences, ambitions, opinions, and plans, although with some awkwardness or hesitation."
        ], [
            "Can fulfill most communication goals, even on unfamiliar topics.",
            "Can understand the main ideas of both concrete and abstract writing.",
            "Can interact with proficient speakers fairly easily.",

        ], [
            "Can understand a variety of demanding written and spoken language including some specialized language use situations.",
            "Can grasp implicit, figurative, pragmatic, and idiomatic language.",
            "Can use language flexibly and effectively for most social, academic, and professional purposes.",

        ]

    ]
}